module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1"
  }, [_c('p', {
    staticClass: "EPIGRAPH"
  }, [_vm._v("The Lord said, “I have heard the cry of my people.”")]), _vm._v(" "), _c('p', {
    staticClass: "EPICREDIT _idGenParaOverride-1"
  }, [_vm._v("adapted from Exodus 3:7")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-491c7d81","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Wolterstorff_The_God_We_Worship_text_CC.vue
// module id = 57
// module chunks = 0